import { useMemo } from 'react';
import { clearAccessTokens } from '@ecp/common/src/utils/utils';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {PAGE_ID} from '@ecp/common/src/const/redirectConst';
import * as Netfunnel from '@ecp/common/src/utils/netfunnel.d.ts';


const useLoginForward = (siteNumber, showConfirmDialog, pageId, contentsNo) => {

    const navigate = useNavigate();
    const isSkypassMall = useMemo(()=>(siteNumber === 'N2507000011'), [siteNumber]);
    var host = window.location.host;
        
    return useCallback(() => {
        var returnUrl = ''; 
        var redirectUrl = '';
          showConfirmDialog(
          '로그인이 필요한 서비스입니다. \n 로그인 하시겠습니까?',
          () => { 

                    if (isSkypassMall) {
                            Netfunnel.NetFunnel_Action({ action_id: 'skypass_login' }, () => {
                            Netfunnel.NetFunnel_Complete({}, () => {});        
                            });
                    }             
                    clearAccessTokens();

                    var page_url = "";                                         
                    switch (pageId) {
                        case PAGE_ID.EVENT:
                            page_url = isSkypassMall ? `?page_id=${pageId}@AND@eventNo=${contentsNo}`:`?page_id=${pageId}&eventNo=${contentsNo}`;
                            break;
                        case PAGE_ID.GOOD :
                            page_url = isSkypassMall ? `?page_id=${pageId}@AND@good_no=${contentsNo}`:`?page_id=${pageId}&good_no=${contentsNo}` ;
                            break;
                        case PAGE_ID.EXHIBITION  :
                            page_url = isSkypassMall ? `?page_id=${pageId}@AND@disp_ctg_no=${contentsNo}`:`?page_id=${pageId}&disp_ctg_no=${contentsNo}`;
                            break;    
                        case PAGE_ID.MQNA  :
                            page_url = `?page_id=${pageId}`;
                            break;  
                        case PAGE_ID.CQNA  :
                            page_url = `?page_id=${pageId}`;
                            break;      
                        case PAGE_ID.GIFTSHOW  :
                            page_url = `?page_id=${pageId}`;
                            break;
                        case PAGE_ID.ORDER  :
                            page_url = `?page_id=${pageId}`;
                            break;             
                        default :
                            page_url += ``;
                    }
                    
                    if (process.env.REACT_APP_ENV === 'local') {
                        var temp_url = `/secure/login/initKOAIRLogin.action?T=%7B%22access_token%22%3A%22eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxMTUyMTc3MjE1MDEiLCJqdGkiOiI4NDUxZDI0NS0zNzZhLTQ2NTktODdhMS1iNmJkMzc4YzNhY2QiLCJpYXQiOjE2MDU3Nzk3MTMsImV4cCI6MTYwNTc4MTUxMywic2NvcGUiOiJhY2Nlc3MiLCJhdXRob3JpdGllcyI6W10sInBheWxvYWQiOnt9fQ.gk0CdmDLUneN1GpbLb10qjHNS83egXywdWP1Aj2pXs4VF0qDRtv-alpwpTb7PMWA0ORLNUo407RLIQti6lnEnF2ta8NXJ0FHnK5P2t60IbNWokB7wLwNTxpO47cXiF_aJYZH9A5d31ucvDmtLsG_RqzM1FM3xOh96Fm487c79kRG5fixfTjAPjzfCSXgAVRcIJhMZv-1dRvo9zXm6DIE3tswByOHKBqVb5oGZZf38khIBMO1OcF4q5usfMcKb89ryxbhJsAhOz52DHYdH3Er6MCCnbsBSvnoexEbg0i90dU4Iu6LntMc35OMTCZ3RfPlgbrivuwpa4j60YyQY7Jt0Q%22%2C%22refresh_token%22%3A%22%22%2C%22expires_in%22%3A1800000%7D&page_id=${pageId}&good_no=${contentsNo}`;
                        isSkypassMall ?   window.location.href = temp_url 
                                                    : navigate('/login' + page_url);
                    } if (process.env.REACT_APP_ENV === 'stg') {
                        returnUrl = 'https://stgoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
                        redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo') ? 
                                                                        '?redirectUrl=https://' + host +'/mobile/secure/login/initKOAIRLogin.action'
                                                                        :'?redirectUrl=https://' + host +'/secure/login/initKOAIRLogin.action';

                        isSkypassMall ?   window.location.href =  'https://wwwstgt.koreanair.com/gw/ssoLoginWelstory.html?kecom_key=@llowMe!96881215&lang=ko&site=welstory&lang=ko&returnUrl=' + returnUrl + redirectUrl + page_url
                                                    : navigate('/login' + page_url);
                    } else {
                        returnUrl = 'https://ecoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';

                        redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo') ?
                                                                            '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
                                                                           :'?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
                        isSkypassMall ?   window.location.href =  'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl='+ returnUrl + redirectUrl + page_url
                                                    : navigate('/login' + page_url);
                    }
                    
                },
          );  
      }, []);
    
};

export const useLogin = (siteNumber) => {

    const navigate = useNavigate();
    const isSkypassMall = useMemo(()=>(siteNumber === 'N2507000011'), [siteNumber])  

    return useCallback(() => {
        var returnUrl = ''; 
        var redirectUrl = '';
        var host = window.location.host;
        
        if (isSkypassMall) {
            Netfunnel.NetFunnel_Action({ action_id: 'skypass_login' }, () => {
            Netfunnel.NetFunnel_Complete({}, () => {});        
            });
        }

        clearAccessTokens();

        if (process.env.REACT_APP_ENV === 'local') {
            var temp_url = `/secure/login/initKOAIRLogin.action?T=%7B%22access_token%22%3A%22eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxMTUyMTc3MjE1MDEiLCJqdGkiOiI4NDUxZDI0NS0zNzZhLTQ2NTktODdhMS1iNmJkMzc4YzNhY2QiLCJpYXQiOjE2MDU3Nzk3MTMsImV4cCI6MTYwNTc4MTUxMywic2NvcGUiOiJhY2Nlc3MiLCJhdXRob3JpdGllcyI6W10sInBheWxvYWQiOnt9fQ.gk0CdmDLUneN1GpbLb10qjHNS83egXywdWP1Aj2pXs4VF0qDRtv-alpwpTb7PMWA0ORLNUo407RLIQti6lnEnF2ta8NXJ0FHnK5P2t60IbNWokB7wLwNTxpO47cXiF_aJYZH9A5d31ucvDmtLsG_RqzM1FM3xOh96Fm487c79kRG5fixfTjAPjzfCSXgAVRcIJhMZv-1dRvo9zXm6DIE3tswByOHKBqVb5oGZZf38khIBMO1OcF4q5usfMcKb89ryxbhJsAhOz52DHYdH3Er6MCCnbsBSvnoexEbg0i90dU4Iu6LntMc35OMTCZ3RfPlgbrivuwpa4j60YyQY7Jt0Q%22%2C%22refresh_token%22%3A%22%22%2C%22expires_in%22%3A1800000%7D`;
            isSkypassMall ?   window.location.href = temp_url 
                                        : navigate('/login');
        } if (process.env.REACT_APP_ENV === 'stg') {
            returnUrl = 'https://stgoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
            redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo') ? 
                                                            '?redirectUrl=https://' + host +'/mobile/secure/login/initKOAIRLogin.action'
                                                            :'?redirectUrl=https://' + host +'/secure/login/initKOAIRLogin.action';

            isSkypassMall ?   window.location.href =  'https://wwwstgt.koreanair.com/gw/ssoLoginWelstory.html?kecom_key=@llowMe!96881215&lang=ko&site=welstory&lang=ko&returnUrl=' + returnUrl + redirectUrl
                                        : navigate('/login');
        } else {
             returnUrl = 'https://ecoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';

             redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo') ?
                                                                 '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
                                                                :'?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
            isSkypassMall ?   window.location.href =  'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl='+ returnUrl + redirectUrl
                                        : navigate('/login');
        }

    }, []);
  
};
    
export default useLoginForward;